import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { useRadio } from './hooks/useRadio.js';
import { Wrapper, Field, StyledRadio, Label } from './styles.js';

const Radio = (_a) => {
    var { id, disabled, label, value, error: errorProp } = _a, props = __rest(_a, ["id", "disabled", "label", "value", "error"]);
    const { name, onChange, selectedRadio, readOnly, error: errorContext, } = useRadio();
    const checked = selectedRadio === value;
    const error = errorContext || errorProp;
    return (React.createElement(Wrapper, { hasLabel: Boolean(label) },
        React.createElement(Field, Object.assign({}, props, { id: id || String(value), name: name, value: value, error: error, readOnly: readOnly, onChange: onChange, disabled: disabled || readOnly, "aria-readonly": readOnly, checked: checked, type: "radio", hasLabel: Boolean(label) })),
        React.createElement(StyledRadio, { error: error, disabled: disabled, readOnly: readOnly }),
        label && React.createElement(Label, { htmlFor: id || String(value) }, label)));
};
Radio.displayName = 'RadioGroup.Radio';

export { Radio as default };
